import { render, staticRenderFns } from "./PriorityList.vue?vue&type=template&id=1f9cf208&scoped=true&"
import script from "./PriorityList.vue?vue&type=script&lang=js&"
export * from "./PriorityList.vue?vue&type=script&lang=js&"
import style0 from "./PriorityList.vue?vue&type=style&index=0&id=1f9cf208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9cf208",
  null
  
)

export default component.exports